// extracted by mini-css-extract-plugin
var _1 = "kqbwpAfch2";
export { _1 as "root" }
